import { render, staticRenderFns } from "./VBackButton.vue?vue&type=template&id=655f39cb&"
import script from "./VBackButton.vue?vue&type=script&lang=ts&"
export * from "./VBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./VBackButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports